module.exports = __webpack_public_path__ + "static/media/agriculture.aedfcf47.jpg";